"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getComboDefaultPostingTime = void 0;
const constants_1 = require("@daytrip/constants");
const getEOPhaseDurationInMinutes_1 = require("../assignationAutomation/getEOPhaseDurationInMinutes");
const getTimeDiff_1 = require("../getTimeDiff");
const PERSONAL_COMBO_DELAY_TRERESHOLDS = {
    best: 28,
    mediocre: 21,
    worst: 21,
};
const CLEAN_COMBO_DELAY_TRERESHOLDS = {
    best: 28,
    mediocre: 21,
    worst: 21,
};
const COMBO_ROUTE_DELAY_TRESHOLDS = {
    best: 28,
    mediocre: 21,
    worst: 15,
};
const getComboDefaultPostingTime = ({ isPersonal, comboPricingCountryId, comboQuality, departureAtUtc, hasComboPredictedRoute, skipEOPhase, }) => {
    if (hasComboPredictedRoute && comboPricingCountryId !== constants_1.ITALY_COUNTRY_ID) {
        const comboRouteDaysToWait = COMBO_ROUTE_DELAY_TRESHOLDS[comboQuality];
        return getDaysToWaitWithEOTime(departureAtUtc, comboRouteDaysToWait, isPersonal, skipEOPhase);
    }
    const tresholds = isPersonal ? PERSONAL_COMBO_DELAY_TRERESHOLDS : CLEAN_COMBO_DELAY_TRERESHOLDS;
    const defaultDaysToWait = tresholds[comboQuality];
    const addedDays = countryBasedAdjustment(comboPricingCountryId, comboQuality);
    const daysToWait = defaultDaysToWait + addedDays;
    return getDaysToWaitWithEOTime(departureAtUtc, daysToWait, isPersonal, skipEOPhase);
};
exports.getComboDefaultPostingTime = getComboDefaultPostingTime;
function getDaysToWaitWithEOTime(departureAtUtc, daysToWait, isPersonal, skipEOPhase) {
    if (isPersonal || skipEOPhase) {
        return daysToWait;
    }
    const daysToDeparture = (0, getTimeDiff_1.getTimeDiffInDays)(departureAtUtc);
    const eoDurationDays = (0, getEOPhaseDurationInMinutes_1.getEOPhaseDurationInMinutes)(daysToDeparture) / constants_1.DAY_IN_MINUTES;
    // Case when combo will be posted on default treshold
    if (daysToDeparture - eoDurationDays > daysToWait) {
        return daysToWait;
    }
    // Case when the default treshold needs to be extended to ensure EO phase
    return daysToDeparture - eoDurationDays;
}
const ITALY_ADDED_DAYS = {
    best: 21,
    mediocre: 14,
    worst: 0,
};
function countryBasedAdjustment(comboPricingCountryId, comboQuality) {
    if (comboPricingCountryId === constants_1.ITALY_COUNTRY_ID) {
        return ITALY_ADDED_DAYS[comboQuality];
    }
    return 0;
}
//# sourceMappingURL=getComboDefaultPostingTime.js.map